const dcUtil = require("../../entry/dc")

BatchEnabled = false    // 请求合并开关
CachedBatchHttp = []    // 请求合并用，保存缓存下来的请求内容
CachedBatchBusy = false
Http.QueueSize = 0      // 请求合并用，同时正在同时请求的数量
Http.QueueSizeMax = 4   // 请求合并用，超过同时上限请求会被缓存
Http.UseHost = 1        // 双域名当前用的是哪个

Http.GET = "GET"
Http.POST = "POST"
Http.DEFAULT_TIMEOUT = 5
Http.LOADING_TIMEOUT = 10

// let falg = ""
// Http.Entry = HTTP_HOST + "/xclover/api/login.php?op=login"
let baseUrl = getParameterByName("_host")
let baseUrl2 = getParameterByName("_host2")
console.log("baseUrl:"+baseUrl)
console.log("baseUrl2:"+baseUrl2)
if (!baseUrl) {
    baseUrl = HTTP_HOST
    if (!(typeof(HTTP_HOST2) == "undefined")){
        baseUrl2 = HTTP_HOST2
    }  
}

Http.loginHost = baseUrl + "/h5Clover/login"
Http.host = baseUrl + "/protocol"

//Http.loginHost = baseUrl + getAlias(LOGIN_PATH)
//Http.host = baseUrl + getAlias(HTTP_PROTOCOL)

let hostQuery = getParameterByName("_qamode") ? "env=qa" : HTTP_HOST_QUERY
Http.hostQuery = hostQuery

// 双域名切换
Http.SwitchHost = function(){
    console.log("SwitchHost baseUrl", baseUrl)
    console.log("SwitchHost baseUrl2", baseUrl2)
    if (Http.UseHost == 1){
        Http.loginHost = baseUrl2 + LOGIN_PATH
        Http.host = baseUrl2 + HTTP_PROTOCOL
        Http.UseHost = 2
    }else{
        Http.loginHost = baseUrl + LOGIN_PATH
        Http.host = baseUrl + HTTP_PROTOCOL
        Http.UseHost = 1
    }
    console.log("SwitchHost Http.loginHost="+Http.loginHost)
}

SERVER_GLOBAL_CODE = {
    HTTP_OK: 0,
    NOT_LOGIN: 112,
    USER_NOT_FOUND: 113,
    SERVER_CLOSED:760204,
    SERVER_CLOSED_LOGIN:111,
    SERVER_BLACK_LIST:109 //黑名单
}

HTTP_RET_CODE = {
    HTTP_OK: 200
}
function HookCallback(callbacks) {
    let called = false
    function cb(fn) {
        return function () {
            if (typeof fn === "function" && !called) {
                called = true
                fn(...arguments)
            }
        }
    }
    for (const key in callbacks) {
        callbacks[key] = cb(callbacks[key])
    }
    return callbacks
}
function Http(url, method, params, callback, timeout, target, filer, headers = null, batched = false) {
    if (BatchEnabled == false){
        batched = false
    }
    this.batched = batched
    this.url = url
    if (batched == true){
        this.callback = []
        for (let i = 0; i < callback.length; i++) {
            let cb = HookCallback(callback[i])
            this.callback.push(cb)
        }
    }else{
        this.callback = HookCallback(callback)
    }
    this.isDone = false
    this.target = target
    this.filer = filer
    var [final_url, urlParams] = buildParamsAndUrl(url, method, params, target, batched)
    var xhr = this.xhr = new XMLHttpRequest();
    xhr.onerror = (err) => this.onError(err)
    xhr.withCredentials = true;
    xhr.timeout = (timeout || Http.DEFAULT_TIMEOUT) * 1000
    xhr.ontimeout = () => this.onTimeOut()
    xhr.onreadystatechange = () => this.onReadyStateChange()
    console.info("request url:" + final_url)
    console.info("params:" + urlParams)
    xhr.open(method, final_url)
    if (method === Http.POST) {
        xhr.setRequestHeader("Content-Type", "application/json");
    }
    if (headers) {
        if (batched == true){
            for (const key in headers[0]) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }else{
            for (const key in headers) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    }
    xhr.send(urlParams, xhr.timeout)
    setTimeout(function(){
        if (this && this.isDone == false){
            LogToLogCenter(new Error(`http force timeout, QueueSize${Http.QueueSize}`))
            // this.onTimeOut()
            // Http.QueueSize = Http.QueueSize - 1
            // this.isDone = true
            // if (CachedBatchHttp.length > 0){
            //     Http.loadCachedBatch()
            // }
        }
    }, (Http.LOADING_TIMEOUT + Http.DEFAULT_TIMEOUT) * 1000)
}

Http.prototype.onTimeOut = function () {
    cc.log(`request ${this.url} time out`)
    if (this.callback && this.callback.onTimeOut) {
        this.callback.onTimeOut("timeout")
    }
}

Http.prototype.onError = function (err) {
    if (this.callback && this.callback.onFail) {
        this.callback.onFail("http_error." + err)
    }
}

Http.prototype.onReadyStateChange = function () {
    let self = this;
    //
    let loadFail = function () {
        let handleFail = function (batchedIdx = null) {
            if (self.callback) {
                let callback = self.callback
                if (batchedIdx != null) {
                    callback = self.callback[batchedIdx]
                }
                callback.onFail && callback.onFail("http_error.statusCode=" + self.xhr.status)
            }
        }
        if (self.batched == true) {
            for (let i = 0; i < self.target.length; i++) {
                handleFail(i)
            }
            let urls = "";
            if (self.target) {
                urls = self.target.join("_");
            }
            window.logCenter && logCenter.error(new Error(`http loadCachedBatch failed. ${urls}`), 'httpLoadCachedBatch')
        } else {
            handleFail()
        }
    }
    
    if (this.xhr.readyState === 4) {
        if (this.xhr.status >= 200 && this.xhr.status < 207) {
            // 解析 返回值
            let self = this
            // console.log("[target] ",self.target)
            self.useResponse = self.xhr.response
            let handleResponse = function(batchedIdx = null){
                let [flag, result] = self.filer(self.useResponse, batchedIdx)
                console.info("[http] response batchedIdx:"+batchedIdx+" '" + self.target + "':", result) ;
                // if (!flag) {
                //     if (callback && callback.onFail) {
                //         callback.onFail("data_error")
                //     }
                //     return
                // }
                let callback = self.callback
                if (batchedIdx != null){
                    callback = self.callback[batchedIdx]
                }
                if (result.code === SERVER_GLOBAL_CODE.HTTP_OK) {
                    let data = result.data && $table(result.data, false)
                    callback.handler(self.target, data, null)
                } else if (result.code === SERVER_GLOBAL_CODE.NOT_LOGIN) {
                    cc.log("cookie timeout")
                    cc.log(result)
                    Toast.make("登录已经超时，即将刷新页面！", 3, function () {
                        // window.location.reload()
                        GameProxy.getInstance().refresh()
                    })
                } else if (result.code === SERVER_GLOBAL_CODE.USER_NOT_FOUND) {
                    function okCallback() {
                        GameProxy.getInstance().popBack()
                    }
                    let data = {
                        text: "您的账号在其他地方登入，导致您离开游戏。请注意账号安全，尽快修改密码。",
                        needOkBtn: true,
                        needCancelBtn: false,
                        okBtnText: "确定",
                    }
                    require("clover/sns/SnsProxy").getInstance().showDialog(data, okCallback)
                } else if (result.code === SERVER_GLOBAL_CODE.SERVER_CLOSED){
                    console.log("[####]server is closed")
                    if (window.mini){
                        let miniPf = window.mini.getPlatform()
                        if (miniPf == MiniPlatform.vivo || miniPf == MiniPlatform.oppoQuickgame){
                            Toast.make("服务器维护中 请稍后再试", 3 , ()=>{
                                mini.exitMiniProgram({})
                            })
                        }else{
                            mini.showModal({
                                title: "服务器维护中 请稍后再试",
                                showCancel: false,
                                success: function (res) {
                                    mini.exitMiniProgram({})
                                }
                            })
                        }
                    }else{
                        Toast.make("服务器维护中 请稍后再试")
                    }
                    /*
                    function okCallback() {
                        if (window.mini){
                            window.mini.exitMiniProgram({})
                        }
                    }
                    let data = {
                        text: "服务器维护中 请稍后再试",
                        needOkBtn: true,
                        needCancelBtn: false,
                        okBtnText: "确定",
                    }
                    require("clover/sns/SnsProxy").getInstance().showDialog(data, okCallback)*/
                } else if(result.code === SERVER_GLOBAL_CODE.SERVER_BLACK_LIST){
                    callback.handler(self.target, null, result.data || 0)
                }else {
                    callback.handler(self.target, null, result.code || 0)
                }
            }
            self.useResponse = HttpEncryptedLogic.getInstance().checkDecrypt(self.xhr,self.target)
            // console.log("[encrypt] 最终useResponse ",self.useResponse)
            if (this.batched == true){
                for (let i = 0; i < this.target.length; i++) {
                    handleResponse(i)            
                }
                // CachedBatchHttp = []
                // CachedBatchBusy = false
            }else{
                handleResponse()
            }
        } else {
            cc.log("Http ERROR xhr.readyState is:", this.xhr.readyState, "xhr.status is: ", this.xhr.status, this.xhr.statusText)
            cc.log("Http ERROR Status Code:" + this.xhr.status)
            //浏览器触发
            loadFail();
        }
        Http.QueueSize = Http.QueueSize - 1
        this.isDone = true
        if (CachedBatchHttp.length > 0){
            Http.loadCachedBatch()
        }
    }else if (this.xhr.readyState === 5){
        cc.log("Http FAIL xhr.readyState is:", this.xhr.readyState, "xhr.status is: ", this.xhr.status, this.xhr.statusText)
        cc.log("Http FAIL Status Code:" + this.xhr.status)
        //小程序触发
        loadFail();
        Http.QueueSize = Http.QueueSize - 1
        if (CachedBatchHttp.length > 0){
            Http.loadCachedBatch()
        }
    }
}

Http.send = function (url, method, params, callback, timeout, target, filer, headers, batched) {
    return new Http(url, method, params, callback, timeout, target, filer, headers, batched)
}

// TODO: encode and decode
// function encode(data) {
//     if (!data) {
//         return data
//     }else {
//     }
// }
// function decode(data) {
// }

function parse_response(result, batchedIdx = null) {
    let data2
    let status
    let falg = false
    try {
        result = JSON.parse(result)
        if (isArray(result)) {
            falg = true
            let resultReal = result[1]
            if (batchedIdx != null){
                data2 = resultReal[batchedIdx] || table()
            }else{
                data2 = resultReal[0] || table()
            }
            status = result[0] || table()
        } else if (result.hasOwnProperty("code")) {
            return parse_response3(result)
        } else {
            data2 = table()
            status = table()
        }
    } catch (error) {
        data2 = table()
        status = table()
    }

    let errCode = status.errCode
    let ts = status.ts
    let retCode = data2.retCode
    let code = 100
    if (ts) {
        let diff = os.difftime(ts, os.time())
        let curDiff = _G.__g_utcDiffSeconds
        if (!curDiff || Math.abs(curDiff - diff) > 300) {
            _G.__g_utcDiffSeconds = diff
            //因为是强联网，此处留在内存即可，没必要落地
            // Localhost.saveTimeDiff(__g_utcDiffSeconds)
        }
    }

    if (errCode !== SERVER_GLOBAL_CODE.HTTP_OK) {
        code = errCode
        falg = false
    } else if (errCode === SERVER_GLOBAL_CODE.HTTP_OK && retCode !== HTTP_RET_CODE.HTTP_OK) {
        code = retCode
    } else if (errCode === SERVER_GLOBAL_CODE.HTTP_OK && retCode === HTTP_RET_CODE.HTTP_OK) {
        code = 0
    }
    let data = {
        code: code,
        data: data2,
        desc: retCode
    }
    return [falg, data]
}

function parse_response2(result) {
    let falg = false
    let data
    try {
        data = JSON.parse(result)
        falg = true
    } catch (error) {
        data = table()
    }
    return [falg, data]
}

function parse_response3(result) {
    let falg = false
    let data
    if (typeof result == "string") {
        try {
            data = JSON.parse(result)
            falg = true
        } catch (error) {
            data = table()
        }
    }else if(typeof result == "object"){
        data = result
        falg = true
    }else{
        data = table()
    }
    let new_data = {}
    new_data.code = data.code
    new_data.data = data
    new_data.desc = data.desc || data.code
    return [falg, new_data]
}

function buildParamsAndUrl(url, method, params, target, batched) {
    if (url === undefined || url === "") {
        return []
    }
    let url_has_param = url.indexOf("?") > 0 ? true : false;
    let dealed_params = formatParams(params, method)
    let flag = url_has_param ? "&" : "?";
    url += flag + "t=" + new Date().getTime()
    url += "&" + "token=" + tostring(_G.token || 0)
    url += "&" + "newToken=" + encodeURIComponent(tostring(_G.token || 0))
    if (batched == false){
        url += "&" + "method=" + target
    }else{

    }
    if (method === Http.GET && dealed_params) {
        url = url + "&" + dealed_params
        return [url, null]
    } else {
        return [url, dealed_params]
    }
}

function formatParams(data, method) {
    if (!data) {
        return null
    } else if (typeof data === "string") {
        return data
    }
    if (method === Http.POST) {
        // data = $tableToObj(data)
        // if(data.__isLuaTable){
        //     data = $tableToObj(data)
        // }else if (isArray(data) && !data.__isLuaTable){
        //     for (var key in data) {
        //         if (data.hasOwnProperty(key)) {
        //             var element = data[key];
        //             if (element.__isLuaTable) {
        //                 data[key] = $tableToObj(element)
        //             }
        //         }
        //     }
        // }
        let newData = HttpEncryptedLogic.getInstance().checkEncrypt(data)
        return JSON.stringify(newData)
    }
    var arr = [];
    for (var name in data) {
        let value = data[name]
        // 手工过滤 #
        if (!value && value !== "#") {
            continue
        }
        arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
    return arr.join("&");
}
function sign(data) {
    let md5 = require("clover/utils/md5")
    let sortedKeys = Object.keys(data).sort()
    let md5str = ""
    for (let index = 0; index < sortedKeys.length; index++) {
        let item = data[sortedKeys[index]]
        if (typeof item !== undefined) {
            let value = typeof item === "object" ? JSON.stringify(item) : item
            md5str = md5str.concat(value)
        }
    }
    return md5(md5str + _G.token)
}

function buildPostParam(param, endpoint = null) {
    let build_param = []
    let pf = isWechatGameEnv()? mini.getPlatform(): META.platform;
    let v = "1.10";
    if (GAME_VERSION) v = GAME_VERSION.split("-")[0];
    // cc.log("buildPostParam v",v);

    build_param[0] = {
        "ct": 0,
        "sk": "PyLkmlPN0S7TcXLaKjRqmg32SRg7KOsS",
        "v": v,
        "aid": "7600109803",
        "uk": "vaTM",
        "pf": pf,
        "mv": "1.0.0",
        "others": {
            "seqUDID": "f17c061804c33e02",
            "seqId": META.seqId,
            "dcSession": dcUtil.getDCSession()
        },
        "st": 768,
        "lang": "zh_CN"
    }
    param = $tableToObj(param) || {}
    param.method = endpoint
    build_param[1] = []
    build_param[1].push(param)
    param.sign = sign(param)
    return build_param
}

function buildBatchPostParam(params, endpoints) {
    let build_param = []
    let pf = isWechatGameEnv()? mini.getPlatform(): META.platform;
    let v = "1.10";
    if (GAME_VERSION) v = GAME_VERSION.split("-")[0];
    cc.log("buildPostParam v",v);

    build_param[0] = {
        "ct": 0,
        "sk": "PyLkmlPN0S7TcXLaKjRqmg32SRg7KOsS",
        "v": v,
        "aid": "7600109803",
        "uk": "vaTM",
        "pf": pf,
        "mv": "1.0.0",
        "others": {
            "seqUDID": "f17c061804c33e02",
            "seqId": META.seqId,
            "dcSession": dcUtil.getDCSession()
        },
        "st": 768,
        "lang": "zh_CN"
    }
    
    build_param[1] = []
    for (let i = 0; i < params.length; i++) {
        let param = params[i];
        param = $tableToObj(param) || {}
        param.method = endpoints[i]
        param.sign = sign(param)
        build_param[1].push(param)
    }

    return build_param
}

Http.load = function (url, endpoint, param, callback, timeout, headers = null) {
    let build_param = buildPostParam(param, endpoint)
    
    if (BatchEnabled == false || endpoint == "passLevel"){
        // 不启动请求合并
        // console.log("[http] not cache Http "+endpoint)
    }else if (Http.QueueSize >= Http.QueueSizeMax){
        if (CachedBatchHttp.length == 0 || (CachedBatchHttp.length > 0 && CachedBatchHttp[0]["url"] == url)){
            CachedBatchHttp.push({
                url:url,
                endpoint:endpoint,
                param:param,
                callback:callback,
                timeout:timeout,
                headers:headers,
                batched:true
            })
            console.log("[http] cache Http "+endpoint)
            META.seqId++;
            return
        }
    }

    // console.log("[http] send Http "+endpoint)
    Http.send(url, Http.POST, build_param, callback, timeout, endpoint, parse_response, headers, false)
    META.seqId++;
    if (endpoint == "passLevel"){
        // passlevel不合并，不需要加QueueSize
    }else{
        Http.QueueSize = Http.QueueSize + 1
    }
}

Http.loadCachedBatch = function(){
    let url = null
    let params = []
    let callbacks = []
    let timeout = 10
    let endpoints = []
    let headers = []
    for (let i = 0; i < CachedBatchHttp.length; i++) {
        const e = CachedBatchHttp[i];
        console.log("[http] loadCachedBatch endpoint="+e.endpoint)
        if (url == null){
            url = e.url
        }
        params.push(e.param)
        callbacks.push(e.callback)
        endpoints.push(e.endpoint)
        headers.push(e.headers)
    }
    CachedBatchHttp = []
    let build_param = buildBatchPostParam(params, endpoints)
    Http.send(url, Http.POST, build_param, callbacks, timeout, endpoints, parse_response, headers, true)
    META.seqId++;
    Http.QueueSize = Http.QueueSize + 1
    console.log("[http] loadCachedBatch QueueSize="+Http.QueueSize)
}
Http.get = function (url, param, callback, timeout, target) {
    Http.send(url, Http.GET, param, callback, timeout, target, parse_response2)
    Http.QueueSize = Http.QueueSize + 1
}
Http.post = function (url, param, callback, timeout, target) {
    Http.send(url, Http.POST, param, callback, timeout, target, parse_response3)
    Http.QueueSize = Http.QueueSize + 1
}
// @param url http://...
// @param param a table of param with k, v
// @param callback {onSuccess=function(data)end, onError=function(code, msg)end, onCancel=function()end}
// Http.heGet = function (url, param, callback) {
//     if (!url) {
//         if (callback && callback.onCancel) {
//             callback.onCancel()
//         }
//         return 
//     }
//     if (param && type(param) === "table" && table.size(param) > 0) {
//         var p = ""
//         var ep = string.find(url, "%?")
//         if (ep) {
//             p = "&"
//         } else {
//             p = "?"
//         }
//         for (var k in param) {
//             var v = param[k]
//             url = url + p + k + "=" + he.HeDisplayUtil.urlEncode(v)
//             p = "&"
//         }
//     }
//     var request = he.HttpRequest.createGet(url)
//     var connection_timeout = 3
//     request.setConnectionTimeoutMs(connection_timeout * 1000)
//     request.setTimeoutMs(10 * 1000)
//     function onRegisterFinished(response) {
//         if (response.httpCode !== 200) {
//             if (callback && callback.onError) {
//                 callback.onError(response.httpCode, "response error")
//             }
//         } else if (callback && callback.onSuccess) {
//             callback.onSuccess(response.body)
//         }
//     }
//     he.HttpClient.getInstance().sendRequest(onRegisterFinished, request)
// }
module.exports = Http
